import { useMemo } from 'react'
import links, { routeData } from 'links'
import { usePublicModules } from 'models/city'
import { getModuleTitle } from 'models/settings'

import eat from '../images/marketplace/eat@2x.png'
import sport from '../images/marketplace/sport@2x.png'

import med from '../images/services/med@2x.png'
import cleaning from '../images/services/cleaning@2x.png'
import culture from '../images/services/culture@2x.png'
import institutions from '../images/services/institutions@2x.png'
import mobility from '../images/services/mobility@2x.png'
import police from '../images/services/police@2x.png'
import transport from '../images/services/transport@2x.png'
import vote from '../images/services/elections@2x.png'
import works from '../images/services/works@2x.png'
import dtp from '../images/services/dtp@2x.png'
import garbage from '../images/services/garbage@2x.png'
import territory from '../images/services/territory@2x.png'
import waste from '../images/services/waste@2x.png'
import votes from '../images/services/votes@2x.png'
import nto from '../images/services/nto@2x.png'
import alerts from '../images/services/alerts@2x.png'


type Service = {
  title: string
  image: string
  to: string
}

const useServices = () => {
  const { modules, isFetching } = usePublicModules()

  const services: Service[] = useMemo(() => ([
    {
      image: vote,
      to: links.elections.root,
    },
    {
      image: institutions,
      to: links.institutions.root,
    },
    {
      image: mobility,
      to: links.accessibility.root,
    },
    {
      image: police,
      to: links.police.root,
    },
    {
      image: cleaning,
      to: links.cleaning,
    },
    // {
    //   image: transport,
    //   to: '/',
    // },
    {
      image: med,
      to: links.medicine.root,
    },
    {
      image: works,
      to: links.excavation.root,
    },
    {
      image: culture,
      to: links.culture.root,
    },
    // {
    //   image: dtp,
    //   to: '/',
    // },
    // {
    //   image: waste,
    //   to: links.controlTKO,
    // },
    {
      image: garbage,
      to: links.controlTKO,
    },
    // {
    //   image: votes,
    //   to: links.votings.root,
    // },
    {
      image: territory,
      to: links.serviceArea.root,
    },
    {
      image: alerts,
      to: links.alerts.root,
    },
  ].map((item) => {
    const tag = routeData[item.to]?.tag
    const title = getModuleTitle(modules, tag)
    return {
      ...item,
      title,
    }
  })), [ modules ])

  const marketplaceServices = useMemo(() => ([
    {
      text: 'Выберите, чем будут кормить вашего ребёнка',
      to: links.edu.root,
      image: eat,
    },
    {
      text: 'Всё для спорта и хобби: городской каталог секций и кружков',
      to: links.sport.root,
      image: sport,
    },
  ].map((item) => {
    const tag = routeData[item.to]?.tag
    const title = getModuleTitle(modules, tag)
    return {
      ...item,
      title,
    }
  })), [ modules ])

  return { services, marketplaceServices }
}

export default useServices